<template>
  <li class="order-item">
    <div class="order-info">
      <div>
        <span class="order-number" @click="goOrderDetail"
          >订单号：{{ itemData.orderNumber }}</span
        ><span class="order-time">{{ itemData.createTime }}</span>
      </div>
      <div class="right-action">
        <el-button
          class="ou-btn-text"
          type="text"
          icon="el-icon-delete"
          @click="deleteOrderRecord($event, itemData.id)"
          >删除</el-button
        >
      </div>
    </div>
    <div class="goods-detail">
      <div>
        <div
          v-for="(item, index) in itemData.ocOrderChildList"
          :key="index"
          class="goods-info"
        >
          <div class="order-cover" @click="goOrderDetail">
            <el-image
              :src="
                item.cover ||
                require('@/assets/images/default-bundle-cover.png') ||
                ''
              "
              fit="contain"
            />
          </div>
          <div class="order-name">
            <span @click="goOrderDetail">{{ item.resourceName }}</span>
          </div>
          <div class="order-price">
            <span class="price-span normal">{{
              item.payMoney | paymentText
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="order-pay ou-expand">
      <span class="price-span weight">{{
        itemData.payment | paymentText
      }}</span>
    </div>
    <div class="order-status ou-expand" :class="[statusClass]">
      {{ itemData.status | statusText }}
    </div>
    <div class="order-action ou-expand">
      <div class="action-wrap">
        <div @click="openPayModal" v-show="itemData.status === '0'">支付</div>
        <div v-show="itemData.status === '1'" @click="goAppraise">评价</div>
        <div @click="goMyEvaluate" v-show="itemData.status === '3'">
          查看评价
        </div>
        <div @click="goOrderDetail">订单详情</div>
        <div
          @click="cancelOrder(itemData.id)"
          v-show="itemData.status === '0'"
          style="color: #999999"
        >
          取消订单
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { checkIsBuy } from "@/api/bookstore/bookstore";
import { apiDeleteOrderRecordById, apiCancelOrder } from "@/api/user/order";
export default {
  name: "CartItem",
  props: {
    type: { type: String, default: "preOrder" },
    itemIndex: { type: Number, default: -1 },
    itemData: { type: Object },
  },
  data() {
    return {
      visible: false,
    };
  },
  inject: ["refreshList", "callPay"],
  components: {},
  watch: {},
  computed: {
    ...mapGetters(["userId"]),
    statusClass() {
      let className = "";
      switch (this.itemData.status) {
        case "0":
          className = "waitPay";
          break;
        case "1":
          className = "waitEva";
          break;
        case "2":
          className = "cancel";
          break;
        case "3":
          className = "complete";
          break;
      }
      return className;
    },
  },
  filters: {
    statusText(value) {
      let text = " - ";
      switch (value) {
        case "0":
          text = "待付款";
          break;
        case "1":
          text = "待评价";
          break;
        case "2":
          text = "已取消";
          break;
        case "3":
          text = "已完成";
          break;
      }
      return text;
    },
    paymentText(value) {
      let text = " - ";
      if (value || value === 0) {
        text = Number(value).toFixed(2);
      }
      return text;
    },
  },
  mounted() {},
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    deleteOrderRecord(e, id) {
      this.$confirm(`订单删除后将不可恢复，确定删除此订单？`, "系统提示", {
        type: "warning",
      }).then(() => {
        apiDeleteOrderRecordById({ id, userId: this.userId }).then((res) => {
          this.$message.success("订单记录删除成功");
          this.refreshList();
        });
      });
    },
    goOrderDetail() {
      this.$router.push({
        path: "/user/orderDetail/index",
        query: {
          orderNumber: this.itemData.orderNumber,
          relevanceId: this.itemData.ocOrderChildList[0].relevanceId,
          relevanceId_type: this.itemData.ocOrderChildList[0].sourceType,
        },
      });
    },
    goMyEvaluate() {
      this.$router.push({
        path: "/user/myEvaluate",
        query: { orderId: this.itemData.id },
      });
    },
    goAppraise() {
      this.$router.push({
        path: "/user/orderDetail/orderAppraise",
        query: { orderNumber: this.itemData.orderNumber },
      });
    },
    openPayModal() {
      //判断是否有权限
      checkIsBuy({
        relevanceId: this.itemData.ocOrderChildList[0].relevanceId,
        type: this.itemData.ocOrderChildList[0].sourceType,
      }).then((res) => {
        if (res.data == "1") {
          this.callPay(this.itemData);
        } else {
          this.$message("书架中已存在本商品，无法重复购买");
        }
      });
    },
    cancelOrder(id) {
      this.$confirm(
        `订单取消后如需购买此订单商品需重新下单，确定取消此订单？`,
        "系统提示",
        {
          type: "warning",
        }
      ).then(() => {
        apiCancelOrder({ id }).then((res) => {
          if (!!res.data) {
            this.$message.success("订单取消成功");
            this.refreshList();
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
